import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  firstDiv: {
    padding: theme.spacing(2, 0),
  },
  firstInnerDiv: {
    width: '100%',
    padding: theme.spacing(0, 4),
  },
  secondDiv: {
    paddingBottom: '40px',
  },
  heading: {
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    color: theme.palette.labraText.primary,
  },
  tableGridComponent: {
    border: `1px solid ${theme.palette.dividerV2.main}`,
    borderRadius: 4,
  },
  tcvGridComponent: {
    border: `1px solid ${theme.palette.dividerV2.main}`,
    borderRadius: 4,
    height: '92px',
  },
  value: {
    fontSize: '16px',
    lineHeight: '24px',
    color: theme.palette.textField.dark,
  },
  gridDiv: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(5),
  },
  offerGridLeftUp: {
    border: `1px solid ${theme.palette.dividerV2.main}`,
    borderRadius: '4px 0px 0px 0px',
    borderRight: 0,
    borderBottom: 0,
    display: 'inline-flex',
    alignItems: 'center',
    height: theme.spacing(12.5),
  },
  offerGridLeftBottom: {
    border: `1px solid ${theme.palette.dividerV2.main}`,
    borderRadius: '0px 0px 0px 4px',
    borderRight: 0,
    display: 'inline-flex',
    alignItems: 'center',
    height: theme.spacing(12.5),
  },
  offerGridRightUp: {
    border: `1px solid ${theme.palette.dividerV2.main}`,
    borderRadius: '0px 4px 0px 0px',
    borderBottom: 0,
    display: 'inline-flex',
    alignItems: 'center',
    height: theme.spacing(12.5),
  },
  offerGridRightBottom: {
    border: `1px solid ${theme.palette.dividerV2.main}`,
    borderRadius: '0px 0px 4px 0px',
    display: 'inline-flex',
    alignItems: 'center',
    height: theme.spacing(12.5),
  },
}))
